import { CountryData } from "../types/Country";
import { patientApiUrl } from "./api";

const API_URL = "/Countries";

export const getData = async (): Promise<CountryData[]> => {
  try {
    const res = await patientApiUrl.get<CountryData[]>(API_URL);
    return res.data;
  } catch (error: any) {
    console.error(
      `Get all countries error: ${
        error.response?.data?.message || error.message
      }`
    );
    return []; // Return empty array on error
  }
};

export const getDataById = async (id: number): Promise<CountryData | null> => {
  try {
    const res = await patientApiUrl.get<CountryData>(`${API_URL}/${id}`);
    return res.data;
  } catch (error: any) {
    console.error(
      `Get country error: ${error.response?.data?.message || error.message}`
    );
    return null; // Return null on error
  }
};
